import { useState } from 'react';
import styled from 'styled-components';
import { seriesLogoUrl } from '../series';

const Img = styled.img`
  width: 52px;
  height: auto;
`;

// Logo comes from public/logos/<series>.png — see src/series.js.
function TeamLogo() {
  const [failed, setFailed] = useState(false);

  if (!seriesLogoUrl || failed) return null;

  return (
    <Img
      src={seriesLogoUrl}
      alt="Team Logo"
      onError={() => {
        console.error(`Team logo not found: ${seriesLogoUrl}`);
        setFailed(true);
      }}
    />
  );
}

export default TeamLogo;
